const screenMobileMax = 360;
const screenXxsMin = 400;
const screenXxsMax = 425;
const screenXsMin = 500;
const screenXsMed = 600;
const screenIpadMin = 750;
const screenColorPaintXs = 630;
const screenXsMax = 767;
const screenSmMin = 768;
const screenSmMed = 900;
const screenSmMax = 991;
const screenMdMin = 992;
const screenHeader = 1050;
const screenMdMax = 1199;
const screenLgMin = 1200;
const screenLgMax = 1679;
const screenXlMin = 1680;
const screenModalMobileMax = screenXsMin;
const screenModalTabletMin = screenModalMobileMax + 1;
const screenModalTabletMed = screenSmMin - 1;
const screenModalTabletMax = screenSmMin;
const screenDesktopDesktopMin = screenModalTabletMax + 1;
const screenDesktopDesktopMax = screenMdMax;
const screenDesktopDesktopLargeMin = screenDesktopDesktopMax + 1;
const screenMobileLargeMin = screenMobileMax + 9;

const mediaQueries = {
    screenMobileMax,
    screenXxsMin,
    screenXxsMax,
    screenXsMin,
    screenXsMed,
    screenIpadMin,
    screenColorPaintXs,
    screenXsMax,
    screenSmMin,
    screenSmMed,
    screenSmMax,
    screenMdMin,
    screenHeader,
    screenMdMax,
    screenLgMin,
    screenLgMax,
    screenXlMin,
    screenModalMobileMax,
    screenModalTabletMin,
    screenModalTabletMed,
    screenModalTabletMax,
    screenDesktopDesktopMin,
    screenDesktopDesktopMax,
    screenDesktopDesktopLargeMin,
    screenMobileLargeMin,
};

export default mediaQueries;
